import React from 'react';
import PropTypes from 'prop-types';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {graphql} from 'react-apollo';
import ReactModal from 'react-modal';
import mutateProps from 'utils/mutateProps';

import {
  selectShowDealFinalizing as selectShow,
} from 'flows/deal/status/reducer';

import {
  finalizingMutation as mutation,
  cancelFinalizing as cancelProp,
  finalizingProp as submitProp,
} from 'flows/deal/status';

import DealFinalizingConfirmation from './component';

export const DealFinalizingConfirmationContainer = ({show, submitLoading, submit, cancel}) => (
  <ReactModal
    isOpen={show}
    contentLabel="What happens now?"
    shouldCloseOnOverlayClick
    className="ReactModal"
    ariaHideApp={false}
  >
    <DealFinalizingConfirmation
      sending={submitLoading}
      submit={submit}
      cancel={cancel}
    />
  </ReactModal>
);

DealFinalizingConfirmationContainer.propTypes = {
  deal: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  submitLoading: PropTypes.bool.isRequired,
  submit: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
};

const mapMutation = props => ({
  submit: submitProp(props),
});

export const mapStore = store => ({
  show: selectShow(store),
});

export default compose(
  graphql(mutation, {
    props: mapMutation,
  }),
  mutateProps({name: 'submit'}),
  connect(mapStore, {cancel: cancelProp}),
)(DealFinalizingConfirmationContainer);



// WEBPACK FOOTER //
// ./web/flows/deal/status_transitions/components/DealFinalizingConfirmation/index.js